// src/components/Toast/GlobalToast.tsx
import React from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'

interface ToastItem {
  id: number
  msg: string
  type: 'success' | 'danger' | 'warning' | 'info'
}

export default function GlobalToast() {
  const [items, setItems] = React.useState<ToastItem[]>([])

  React.useEffect(() => {
    const handler = (e: Event) => {
      const { msg, type } = (e as CustomEvent).detail
      const id = Date.now()
      setItems((prev) => [...prev, { id, msg, type }])
      setTimeout(() => {
        setItems((prev) => prev.filter((i) => i.id !== id))
      }, 4000)
    }
    window.addEventListener('ktfc-toast', handler)
    return () => window.removeEventListener('ktfc-toast', handler)
  }, [])

  return (
    <ToastContainer position='top-end' className='p-3' style={{ zIndex: 9999 }}>
      {items.map((item) => (
        <Toast
          key={item.id}
          bg={item.type}
          onClose={() => setItems((prev) => prev.filter((i) => i.id !== item.id))}
        >
          <Toast.Header closeButton>
            <strong className='me-auto'>
              {item.type === 'success' && '✅ สำเร็จ'}
              {item.type === 'danger'  && '❌ เกิดข้อผิดพลาด'}
              {item.type === 'warning' && '⚠️ แจ้งเตือน'}
              {item.type === 'info'    && 'ℹ️ ข้อมูล'}
            </strong>
          </Toast.Header>
          <Toast.Body className={item.type === 'danger' || item.type === 'success' ? 'text-white' : ''}>
            {item.msg}
          </Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  )
}
